import { createServerFn } from "@tanstack/react-start";
import { logError } from "@/lib/structured-log";

export interface ClerkPublishableKeyPayload {
  publishableKey: string;
}

let cachedPublishableKey: string | null = null;

export const getClerkPublishableKeyServer = createServerFn({ method: "GET" }).handler(
  async (): Promise<ClerkPublishableKeyPayload> => {
    if (cachedPublishableKey) {
      return { publishableKey: cachedPublishableKey };
    }

    const publishableKey = process.env.CLERK_PUBLISHABLE_KEY;

    if (!publishableKey) {
      logError("clerk.publishable_key.missing_env", {});
      throw new Error("CLERK_PUBLISHABLE_KEY is not configured.");
    }

    cachedPublishableKey = publishableKey;

    return { publishableKey };
  },
);
